import React, { useState, useEffect, useRef, useCallback } from "react";
import { secondAndMinute } from "../helper";

const OfflineSessionTimer = (props) => {
  const [minutes, setMinutes] = useState(props?.minutes);
  const [seconds, setSeconds] = useState(props?.seconds);
  const [timeStop, settimeStop] = useState(false);
  const myInterval = useRef();

  useEffect(() => {
    clearInterval(myInterval.current);
    myInterval.current = setInterval(() => {
      if (seconds > 0) {
        setSeconds(seconds - 1);
      }
      if (seconds === 0 && !timeStop) {
        if (minutes === 0) {
          clearInterval(myInterval.current);
          settimeStop(true);
          props.handleSessionEnd();
        } else {
          setMinutes(minutes - 1);
          setSeconds(59);
        }
      }
    }, 1000);
  });

  useEffect(() => {
    if (props.offline_session_start_time && props.startTime) {
      const data = secondAndMinute(props.offline_session_start_time);
      if (data.minutes >= 0 && data.seconds >= 0) {
        setMinutes(data.minutes);
        setSeconds(data.seconds);
      } else {
        clearInterval(myInterval.current);
      }
    }
    return () => {
      clearInterval(myInterval.current);
    };
  }, [props.startTime]);

  const secondTime = useCallback(() => {
    if (seconds < 10) {
      return `0${seconds}`;
    } else {
      return seconds;
    }
  }, [seconds]);

  return (
    <div className="ml-1">
      {minutes === 0 && seconds === 0 ? (
        <h6>00:00</h6>
      ) : (
        <h6>
          {" "}
          {minutes}:{secondTime()}
        </h6>
      )}
    </div>
  );
};

export default OfflineSessionTimer;
